<template>
  <b-container>
    <b-row>
      <b-col col md="12" class="p-0">
        <h4 class="font-weight-bold mb-4 mb-md-5">Edit Profile</h4>

        <b-form @submit.prevent="onSubmit" v-if="user">
          <b-row no-gutters>
            <b-col cols="12" md="6" class="m-0">
              <b-form-group class="col-12">
                <h6>Name</h6>
                <b-form-input
                  v-model="form.full_name"
                  class="form-control effect-26"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group class="col-12">
                <h6>Handle</h6>
                <b-form-input
                  v-model="form.username"
                  class="form-control effect-26"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group class="col-12" v-if="user.email">
                <h6>Email <small class="grey-dark">(cannot change)</small></h6>
                <b-form-input
                  v-model="user.email"
                  class="form-control effect-26"
                  type="text"
                  ref="field-email"
                  disabled
                ></b-form-input>
              </b-form-group>

              <!--<b-form-group class="col-12" v-if="user.country">-->
              <!--<h6>Country</h6>-->
              <!--<b-form-select-->
              <!--v-model="form.country"-->
              <!--:options="countries"-->
              <!--class="form-control effect-26"-->
              <!--value-field="item"-->
              <!--text-field="name"-->
              <!--/>-->
              <!--</b-form-group>-->
            </b-col>

            <b-col cols="12" md="6" class="pl-md-4">
              <b-form-group class="col-12">
                <h6>Bio</h6>
                <b-form-textarea
                  rows="16"
                  v-model="form.biography"
                  class="form-control effect-26"
                ></b-form-textarea>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-row>
                <b-col cols="12" md="4" class="m-auto px-3">
                  <b-button
                    class="rounded-pill"
                    type="submit"
                    variant="primary"
                    block
                  >
                    <b-spinner small v-if="form.$busy" /> Save Changes
                  </b-button>

                  <!-- API Error Message -->
                  <div
                    class="mt-4 text-warning"
                    v-if="form.$errorMessage"
                    v-text="
                      'Uh oh, ' + form.$errorMessage.toLowerCase() + ' 😢'
                    "
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'

export default {
  data() {
    return {
      form: new Form({
        full_name: '',
        first_name: '',
        last_name: '',
        username: '',
        country: '',
        biography: '',
      }),
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      countries: (state) => state.auth.countries,
    }),
  },

  methods: {
    ...mapActions({
      getCountries: 'auth/getCountries',
      getUserCard: 'auth/getUserCard',
      getAuthenticatedUser: 'auth/getAuthenticatedUser',
    }),

    async onSubmit(evt) {
      this.form.$busy = true

      await this.$api
        .put('user', this.form.$data())
        .then(({ data }) => {
          this.form.$busy = false
          this.successToast('Successfully updated!')

          this.getAuthenticatedUser()
          this.getUserCard()
        })
        .catch((error) => {
          this.form.$handleError(error)
        })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        noCloseButton: true,
        variant: 'success',
        toaster: 'b-toaster-bottom-right',
      })
    },
  },

  watch: {
    'form.full_name'() {
      this.form.$clearErrorMessage()

      if (this.form.full_name) {
        let name = this.form.full_name.split(' ')
        this.form.first_name = name[0]

        if (name.length > 1) {
          this.form.last_name = name[name.length - 1]
        }
      } else {
        this.form.last_name = ''
      }
    },
    'form.username'() {
      this.form.$clearErrorMessage()
    },
    'form.country'() {
      this.form.$clearErrorMessage()
    },
    'form.biography'() {
      this.form.$clearErrorMessage()
    },
  },

  async mounted() {
    let vm = this

    await vm.getCountries()

    setTimeout(function () {
      vm.form.full_name = vm.user.full_name
      vm.form.first_name = vm.user.first_name
      vm.form.last_name = vm.user.last_name
      vm.form.username = vm.user.username
      // vm.form.country = vm.user.country
      vm.form.biography = vm.user.biography
    }, 1000)
  },
}
</script>

<style lang="scss" scoped></style>
